export type SubscriptionStatus =
  | "active"
  | "trialing"
  | "past_due"
  | "unpaid"
  | "canceled"
  | "incomplete"
  | "incomplete_expired";

export const PAYMENT_ISSUE_STATUSES = new Set<SubscriptionStatus>(["past_due", "unpaid"]);

export const DISPLAYABLE_STATUSES = new Set<SubscriptionStatus>([
  "active",
  "trialing",
  "past_due",
  "unpaid",
]);

export type CancellationEligibleStatus = Extract<
  SubscriptionStatus,
  "active" | "trialing" | "past_due" | "unpaid"
>;

export const CANCELLATION_ELIGIBLE_STATUSES = new Set<CancellationEligibleStatus>([
  "active",
  "trialing",
  "past_due",
  "unpaid",
]);

export function isCancellationEligibleStatus(status: string): status is CancellationEligibleStatus {
  return CANCELLATION_ELIGIBLE_STATUSES.has(status as CancellationEligibleStatus);
}

export const HISTORICAL_SUBSCRIPTION_STATUSES = new Set<SubscriptionStatus>([
  "active",
  "trialing",
  "past_due",
  "unpaid",
  "canceled",
]);

export function hasSubscriptionHistory(status: string): boolean {
  return HISTORICAL_SUBSCRIPTION_STATUSES.has(status as SubscriptionStatus);
}

export function isPaymentIssue(status: string): boolean {
  return PAYMENT_ISSUE_STATUSES.has(status as SubscriptionStatus);
}

export function getStatusLabel(status: string): { text: string; variant: "success" | "warning" | "default" } {
  switch (status) {
    case "active":
      return { text: "Active", variant: "success" };
    case "trialing":
      return { text: "Trial", variant: "default" };
    case "past_due":
    case "unpaid":
      return { text: "Payment Issue", variant: "warning" };
    default:
      return { text: status, variant: "default" };
  }
}
